import React, {useState, useEffect} from 'react';
import {PanelMenu} from 'primereact/panelmenu';
import { useLocation, useHistory } from 'react-router-dom';
import UserProfile from '../../profile/Userprofile';
import StorageHelper from '../../../../utils/storage-helper';

const Sidebar1 = () => {

    StorageHelper.set('sideBarHidden', 'false');

    const [isSidebarVisible, setSidebarVisible] = useState(
        StorageHelper.get('sideBarHidden') !== 'true'
    );
    const [items, setItems] = useState([]);
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const fetchUserPermissions = async () => {
            try {
                const userRole = StorageHelper.get('userRole');
                if (!userRole || !userRole.permissionsGroups) {
                    console.warn('User role or permissions not found');
                    return;
                }

                const userPermissions = userRole.permissionsGroups;
                const currentPath = window.location.pathname.replace(/\/$/, ''); // normalize trailing slash

                let updatedItems = userPermissions.map((permissionsGroup) => {
                    const systemFunctionItems = permissionsGroup.systemFunctions
                        ? permissionsGroup.systemFunctions.map((functionItem) => {
                            const actionPath = functionItem.action ? functionItem.action.replace(/\/$/, '') : '';
                            const isActive = currentPath === actionPath || currentPath.startsWith(actionPath + '/');
                            return {
                                label: functionItem.name,
                                icon: 'pi pi-angle-right',
                                className: isActive ? 'bg-primary/10 text-primary font-bold border-r-4 border-primary' : '',
                                command: (e) => {
                                    // Use React Router for navigation to prevent full page reloads
                                    if (functionItem.action) {
                                        history.push(functionItem.action);
                                    }
                                }
                            };
                        })
                        : [];

                                        // Check if any child is active to expand the parent group
                    const isGroupActive = systemFunctionItems.some(item => {
                        // Determine if a child is active by checking the function closure or active flag
                        // Since we just mapped them, we can check if it has the active class
                        return item.className && item.className.includes('border-primary');
                    });

                    return {
                        label: permissionsGroup.groupName,
                        icon: permissionsGroup.groupIcons || 'pi pi-folder',
                        expanded: isGroupActive, // Auto-expand if a child is active
                        className: isGroupActive ? 'text-primary font-bold' : '',
                        template: (item, options) => {
                            return (
                                <div 
                                    className={`cursor-pointer px-4 py-3 flex items-center justify-between transition-colors ${isGroupActive ? 'text-primary font-bold bg-primary/5' : 'text-base-content/90 font-semibold hover:bg-base-200'}`}
                                    onClick={(e) => options.onClick(e)}
                                >
                                    <div className="flex items-center">
                                        <i className={`mr-3 ${item.icon}`}></i>
                                        <span className="text-sm uppercase tracking-wider">{item.label}</span>
                                    </div>
                                    <i className={`pi ${options.expanded ? 'pi-chevron-down' : 'pi-chevron-right'} text-xs opacity-70`}></i>
                                </div>
                            );
                        },
                        items: systemFunctionItems,
                    };
                });

                const roleName = userRole.name || '';
                const isAuthorized = ['ADMIN', 'UNDERWRITER', 'SUPER_ADMIN'].includes(roleName.toUpperCase());
                if (isAuthorized) {
                    const bcPath = '/policy/beneficiary-requests';
                    const isBcActive = currentPath === bcPath || currentPath.startsWith(bcPath + '/');
                                        const newItem = {
                        label: 'Beneficiary Change Requests',
                        icon: 'pi pi-angle-right',
                        className: isBcActive ? 'bg-primary/10 border-r-4 border-primary' : '',
                        template: (item, options) => (
                            <div 
                                className={`cursor-pointer px-4 py-3 flex items-center transition-colors ${isBcActive ? 'text-primary font-bold bg-primary/5' : 'text-base-content/80 hover:bg-base-200'}`}
                                onClick={(e) => {
                                    options.onClick(e);
                                    history.push(bcPath);
                                }}
                            >
                                <i className={`mr-3 ${item.icon}`}></i>
                                <span className="text-sm">{item.label}</span>
                            </div>
                        )
                    };

                    let policyGroup = updatedItems.find(item =>
                        item.label.toUpperCase() === 'POLICY MANAGEMENT' ||
                        item.label.toUpperCase() === 'POLICY' ||
                        item.label.toUpperCase() === 'APPROVALS' ||
                        item.label.toUpperCase() === 'MANAGE POLICY'
                    );

                    if (policyGroup) {
                        if (!policyGroup.items.some(subItem => subItem.label === 'Beneficiary Change Requests')) {
                            policyGroup.items.push(newItem);
                            if (isBcActive) policyGroup.expanded = true;
                        }
                    } else {
                        updatedItems.push({
                            label: 'Review Approvals',
                            icon: 'pi pi-check-square',
                            expanded: isBcActive,
                            items: [newItem]
                        });
                    }

                    const claimsPath = '/claims/view-all';
                    const isClaimsActive = currentPath === claimsPath || currentPath.startsWith(claimsPath + '/');
                                        const claimsItem = {
                        label: 'View All Claims',
                        icon: 'pi pi-list',
                        className: isClaimsActive ? 'bg-primary/10 border-r-4 border-primary' : '',
                        template: (item, options) => (
                            <div 
                                className={`cursor-pointer px-4 py-3 flex items-center transition-colors ${isClaimsActive ? 'text-primary font-bold bg-primary/5' : 'text-base-content/80 hover:bg-base-200'}`}
                                onClick={(e) => {
                                    options.onClick(e);
                                    history.push(claimsPath);
                                }}
                            >
                                <i className={`mr-3 ${item.icon}`}></i>
                                <span className="text-sm">{item.label}</span>
                            </div>
                        )
                    };

                    if (policyGroup) {
                        if (!policyGroup.items.some(subItem => subItem.label === 'View All Claims')) {
                            policyGroup.items.push(claimsItem);
                            if (isClaimsActive) policyGroup.expanded = true;
                        }
                    } else {
                        let approvalsGroup = updatedItems.find(item => item.label === 'Review Approvals');
                        if (approvalsGroup) {
                            approvalsGroup.items.push(claimsItem);
                            if (isClaimsActive) approvalsGroup.expanded = true;
                        }
                    }
                }

                setItems(updatedItems);
            } catch (error) {
                console.error('Error fetching user permissions:', error);
            }
        };
        fetchUserPermissions();
    }, [location.pathname, history]);

    useEffect(() => {
        StorageHelper.set('sideBarHidden', !isSidebarVisible);
    }, [isSidebarVisible]);

    useEffect(() => {
        // Handler for storage event
        const handleStorageChange = (event) => {
            if (event.key === 'sideBarHidden') {
                setSidebarVisible(event.newValue !== 'true');
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    useEffect(() => {
        if (isSidebarVisible) {
            document.body.classList.add('has-admin-sidebar');
        } else {
            document.body.classList.remove('has-admin-sidebar');
        }
        return () => document.body.classList.remove('has-admin-sidebar');
    }, [isSidebarVisible]);

    return (
        <>
            {isSidebarVisible && (
                <div className="fixed left-0 top-16 h-[calc(100vh-4rem)] w-72 bg-base-100 border-r border-base-200 shadow-sm z-[90] overflow-y-auto flex flex-col transition-all duration-300">
                    <div className="p-4 border-b border-base-200 flex justify-between items-center bg-base-50">
                        <span className="font-bold text-base-content/70 uppercase text-xs tracking-wider">Navigation</span>
                        <button 
                            className="btn btn-ghost btn-xs btn-circle text-base-content/50 hover:text-primary hover:bg-primary/10" 
                            onClick={() => setSidebarVisible(false)}
                            title="Hide Sidebar"
                        >
                            <i className="pi pi-angle-left text-lg"></i>
                        </button>
                    </div>
                    
                    <div className="flex-1 overflow-y-auto p-2">
                        <PanelMenu model={items} multiple={false} className="w-full border-none" />
                    </div>

                    <div className="p-4 border-t border-base-200 mt-auto bg-base-50">
                        <UserProfile />
                    </div>
                </div>
            )}

            {!isSidebarVisible && (
                <div className="fixed left-0 top-20 z-[95]">
                    <button 
                        className="btn btn-primary rounded-r-full rounded-l-none shadow-md"
                        onClick={() => setSidebarVisible(true)}
                        title="Show Sidebar"
                    >
                        <i className="pi pi-bars"></i>
                    </button>
                </div>
            )}
        </>
    );
};

export default Sidebar1;
